module.exports = __webpack_public_path__ + "static/assets/29899ab54eedb418354e0a7875fa4053.svg";